<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
	@import './styles/base.css'; /*引入公共样式*/
	@import './styles/font.css';
	@import 'mint-ui/lib/style.css';
  @import 'element-ui/lib/theme-chalk/index.css';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  overflow-y: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue